import { useState } from "react";
import { useAuth } from "../utils/auth";

const PasswordResetRequest = () => {

    const auth = useAuth();

    const [loginemail, setLoginemail] = useState("");
    const [message, setMessage] = useState("")

    const handleChange = (e) => {
        setLoginemail(e.target.value);
    }

    const handleClick = async () => {
        const data = {
            method: "POST",
            path: "auth/forgotpassword",
            input: {
                loginemail
            }
        }

        const result = await auth.resetpassword(data);
        if (result.success) {
            setMessage("Je ontvangt binnen enkele ogenblikken een mail met een link om je wachtwoord te resetten.");
        }
    }


    return (
        <>
            <div>

                <label htmlFor="loginemail">Loginemail: </label>

                <input 
                    type="text" 
                    name="loginemail" 
                    id="loginemail" 
                    onChange={handleChange} />
                <button className="button small" onClick={handleClick}>Wachtwoord resetten</button>
            </div>
            <div>
                <p>{message}</p>
            </div>
        </>
    );
}

export default PasswordResetRequest;